// Reducer extracted from Services.js

import _ from "lodash";
import update from "immutability-helper";
import { hideIntercom as hideIntercomV1 } from "lib/intercom";
import {
  SET_IS_ONLINE,
  SET_IS_PAGE_NOT_FOUND,
  SET_IS_RESOURCE_UNAVAILABLE,
  SET_IS_AI_USAGE_LIMIT_MODAL,
  SET_PROGRESS,
  REMOVE_PROGRESS_ELEMENT,
  UPDATE_LOCAL_COMMENT,
  INITIALISE_RESOURCEBANK_COMPONENT,
  UPDATE_RESOURCEBANK_FILTERS,
  TOGGLE_RESOURCEBANK_FILTER_ITEM,
  TOGGLE_ALL_RESOURCEBANK_FILTER_ITEMS,
  TOGGLE_RESOURCEBANK_SELECTED_RESOURCES,
  CLEAR_RESOURCEBANK_SELECTED_RESOURCES,
  SET_ORDER_BY_DIRECTION,
  TOGGLE_ACTION_LOADING,
  UPDATE_AUDIO_RECORDER_BLOB,
  SET_PICTURE_IN_PICTURE_DATA,
  UPDATE_GLOBAL_SEARCH_TEXT,
  SET_GLOBAL_SEARCH_VOICE,
  SET_GLOBAL_SEARCH_MODAL,
  SET_GLOBAL_SEARCH_FILTER_MODULE,
  TOGGLE_GLOBAL_SEARCH_MODULE,
  TOGGLE_GLOBAL_SEARCH_VOICE_MODULE,
  TOGGLE_GLOBAL_SEARCH_AND_VOICE_MODULE,
  SET_GLOBAL_SEARCH_COURSES_CONTEXT,
  SET_GLOBAL_SEARCH_CURRICULUM_CONTEXT,
  SET_JUMP_TO_CURRICULUM_CONTEXT,
  SET_UBD_ASSESSMENT_TYPES,
  SHOW_INTERCOM,
  HIDE_INTERCOM,
  SHOW_NOTIFICATION_ICON_GLOBAL_TRAY,
  HIDE_NOTIFICATION_ICON_GLOBAL_TRAY,
  ADD_FEATURE_WITH_KEYBOARD_SHORTCUTS,
  REMOVE_FEATURE_WITH_KEYBOARD_SHORTCUTS,
  SET_ACTIVE_FEATURE_WITH_KEYBOARD_SHORTCUTS,
  SET_AUDIO_RECORDER_ACTIVE,
  SET_NEW_PRODUCT_UPDATES_CALL_OUT_STATE,
  SET_BADGE_OPTIMISTIC_STATE,
  SET_PLATFORM_SWITCHER_TAB,
} from "./ServicesConstants";

// Initial State
const initialState = {
  progressOfUploads: {
    //id: progress
  },
  isOnline: true,
  isPageNotFound: false,
  showAIUsageLimitModal: false,
  isActionLoading: false,
  isResourceUnavailable: false,
  resourceBank: {
    default: {
      filters: {
        searchText: "",
        count: 18,
        selected: {
          sources: [],
          mediaTypes: [],
        },
      },
      selectedResources: [],
    },
  },
  orderByDirectionObj: {
    studentProgressReport: {
      orderBy: null,
      orderByDirection: null,
    },
    adminTeacherFeed: {
      orderBy: "FIRST_NAME",
      orderByDirection: "ASC",
    },
    adminStudentFeed: {
      orderBy: "FIRST_NAME",
      orderByDirection: "ASC",
    },
  },
  createComment: {},
  globalSearchBar: {
    searchText: "",
    module: null,
    showSearchBar: false,
    enableVoiceSearch: false,
    selectedCurriculum: null,
    courses: {
      allCourses: null,
      updatedAt: null,
    },
  },
  jumpTo: {
    selectedCurriculum: null,
  },
  showIntercom: true,
  showNotificationIconGlobal: true,
  featuresWithKeyboardShortcuts: [],
  activeFeatureWithKeyboardShortcuts: null,
  newProductUpdatesCalloutState: {},
  badgeOptimisticState: {},
  platformSwitcherTab: null,
};

const resourceBank = {
  filters: {
    searchText: "",
    count: 18,
    selected: {
      sources: [],
      mediaTypes: [],
    },
  },

  selectedResources: [],
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [SET_PICTURE_IN_PICTURE_DATA]: (state, action) => {
    let url = _.get(action, "data.url", null);
    let mediaType = _.get(action, "data.mediaType", null);
    let videoCurrentTime = _.get(action, "data.videoCurrentTime", null);
    const showPip = _.get(action, "data.showPip", false);
    if (!showPip) {
      url = null;
      mediaType = null;
      videoCurrentTime = null;
    }
    if (mediaType !== "VIDEO") {
      videoCurrentTime = null;
    }
    return update(state, {
      pictureInPictureConfig: {
        $set: {
          url,
          mediaType,
          showPip,
          videoCurrentTime,
          item: _.get(action, "data.item", {}),
        },
      },
    });
  },

  [UPDATE_AUDIO_RECORDER_BLOB]: (state, action) => {
    return update(state, {
      draftRecording: { $set: action.payload },
    });
  },

  [SET_AUDIO_RECORDER_ACTIVE]: (state, action) => {
    return update(state, {
      activeAudioRecorder: { $set: action.payload },
    });
  },

  [SET_IS_ONLINE]: (state, action) => {
    return update(state, {
      isOnline: { $set: action.payload },
    });
  },

  [SET_IS_PAGE_NOT_FOUND]: (state, action) => {
    return update(state, {
      isPageNotFound: { $set: action.payload },
    });
  },
  [SET_IS_RESOURCE_UNAVAILABLE]: (state, action) => {
    return update(state, {
      isResourceUnavailable: { $set: action.payload },
    });
  },
  [SET_IS_AI_USAGE_LIMIT_MODAL]: (state, action) => {
    return update(state, {
      showAIUsageLimitModal: { $set: action.payload },
    });
  },
  [SET_NEW_PRODUCT_UPDATES_CALL_OUT_STATE]: (state, action) => {
    return update(state, {
      newProductUpdatesCalloutState: { $set: action.payload },
    });
  },
  [SET_BADGE_OPTIMISTIC_STATE]: (state, action) => {
    return update(state, {
      badgeOptimisticState: { $set: action.payload },
    });
  },
  [SET_PROGRESS]: (state, action) => {
    const id = action.payload.id;

    const keys = Object.keys(action.payload);
    if (!state.progressOfUploads[id]) {
      state = update(state, {
        progressOfUploads: { [id]: { $set: {} } },
      });
    }
    _.forEach(keys, key => {
      state = update(state, {
        progressOfUploads: { [id]: { [key]: { $set: action.payload[key] } } },
      });
    });

    return state;
  },

  [SET_ORDER_BY_DIRECTION]: (state, action) => {
    const params = action.data;

    Object.keys(params).map((parentKey, index) => {
      if (!state["orderByDirectionObj"][parentKey]) {
        state = update(state, {
          orderByDirectionObj: {
            [parentKey]: {
              $set: { orderBy: "TITLE", orderByDirection: "ASC" },
            },
          },
        });
      }

      Object.keys(params[parentKey]).map((key, index) => {
        state = update(state, {
          orderByDirectionObj: {
            [parentKey]: { [key]: { $set: params[parentKey][key] } },
          },
        });
      });
    });

    return state;
  },
  [REMOVE_PROGRESS_ELEMENT]: (state, action) => {
    const { id } = action.payload;
    const newState = update(state, {
      progressOfUploads: { $set: _.omit(state.progressOfUploads, [id]) },
    });
    return newState;
  },
  [INITIALISE_RESOURCEBANK_COMPONENT]: (state, action) => {
    return update(state, {
      resourceBank: { [action.data]: { $set: resourceBank } },
    });
  },

  [UPDATE_RESOURCEBANK_FILTERS]: (state, action) => {
    const params = action.data.params;
    const id = action.data.id;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        resourceBank: { [id]: { filters: { [key]: { $set: params[key] } } } },
      });
    });
    return state;
  },
  [TOGGLE_ALL_RESOURCEBANK_FILTER_ITEMS]: (state, action) => {
    const stateItemToUpdate = action.data.params.type;
    const id = action.data.id;
    return update(state, {
      resourceBank: {
        [id]: {
          filters: {
            selected: {
              [stateItemToUpdate]: { $set: action.data.params.allList },
            },
          },
        },
      },
    });
  },
  [TOGGLE_RESOURCEBANK_FILTER_ITEM]: (state, action) => {
    const params = action.data.params;
    const value = params.value;
    const opt = params.opt;
    const index = params.index;
    const stateItemToUpdate = params.type;
    const item = _.cloneDeep(params.item);
    const id = action.data.id;
    if (value) {
      return update(state, {
        resourceBank: {
          [id]: {
            filters: { selected: { [stateItemToUpdate]: { $push: [opt] } } },
          },
        },
      });
    } else {
      return update(state, {
        resourceBank: {
          [id]: {
            filters: {
              selected: { [stateItemToUpdate]: { $splice: [[index, 1]] } },
            },
          },
        },
      });
    }
  },
  [TOGGLE_RESOURCEBANK_SELECTED_RESOURCES]: (state, action) => {
    const params = action.data.params;
    const type = params.type;
    const data = params.data;
    const arrayindex = params.index;
    const id = action.data.id;

    if (type == "add") {
      if (arrayindex == "") {
        state = update(state, {
          resourceBank: { [id]: { selectedResources: { $push: [data] } } },
        });
      } else {
        state = update(state, {
          resourceBank: {
            [id]: { selectedResources: { $splice: [[arrayindex, 0, data]] } },
          },
        });
      }
    } else if (type == "delete") {
      state = update(state, {
        resourceBank: {
          [id]: { selectedResources: { $splice: [[arrayindex, 1]] } },
        },
      });
    } else {
      state = update(state, {
        resourceBank: {
          [id]: { selectedResources: { $splice: [[arrayindex, 1, data]] } },
        },
      });
    }
    return state;
  },
  [CLEAR_RESOURCEBANK_SELECTED_RESOURCES]: (state, action) => {
    const id = action.data.id;
    return update(state, {
      resourceBank: { [id]: { selectedResources: { $set: [] } } },
    });
  },
  [UPDATE_LOCAL_COMMENT]: (state, action) => {
    const id = action.data.id;
    const commentData = action.data.commentData;
    return update(state, { createComment: { [id]: { $set: commentData } } });
  },
  [TOGGLE_ACTION_LOADING]: (state, action) => {
    return update(state, {
      isActionLoading: { $set: action.data },
    });
  },
  [UPDATE_GLOBAL_SEARCH_TEXT]: (state, action) => {
    return update(state, {
      globalSearchBar: { searchText: { $set: action.payload } },
    });
  },
  [SET_GLOBAL_SEARCH_VOICE]: (state, action) => {
    return update(state, {
      globalSearchBar: { enableVoiceSearch: { $set: action.payload } },
    });
  },
  [SET_GLOBAL_SEARCH_MODAL]: (state, action) => {
    return update(state, {
      globalSearchBar: { showSearchBar: { $set: action.payload } },
    });
  },
  [SET_GLOBAL_SEARCH_FILTER_MODULE]: (state, action) => {
    return update(state, {
      globalSearchBar: { module: { $set: action.payload } },
    });
  },
  [TOGGLE_GLOBAL_SEARCH_MODULE]: (state, action) => {
    const { showSearchBar, enableVoiceSearch } = state.globalSearchBar;

    const updatedStatusOfVoice = enableVoiceSearch ? false : enableVoiceSearch;

    state = update(state, {
      globalSearchBar: {
        showSearchBar: { $set: !showSearchBar },
        enableVoiceSearch: { $set: updatedStatusOfVoice },
      },
    });

    return state;
  },
  [TOGGLE_GLOBAL_SEARCH_VOICE_MODULE]: (state, action) => {
    const { enableVoiceSearch } = state.globalSearchBar;

    const actionState = _.get(action, "payload.state", undefined);

    const updatedStatusOfVoice =
      actionState !== undefined ? actionState : !enableVoiceSearch;

    state = update(state, {
      globalSearchBar: { enableVoiceSearch: { $set: updatedStatusOfVoice } },
    });

    return state;
  },
  [TOGGLE_GLOBAL_SEARCH_AND_VOICE_MODULE]: (state, action) => {
    const { showSearchBar, enableVoiceSearch } = state.globalSearchBar;

    state = update(state, {
      globalSearchBar: {
        showSearchBar: { $set: !showSearchBar },
        enableVoiceSearch: { $set: !enableVoiceSearch },
      },
    });

    return state;
  },
  [SET_GLOBAL_SEARCH_COURSES_CONTEXT]: (state, action) => {
    const {
      payload: { courses = [] },
    } = action;

    return update(state, {
      globalSearchBar: {
        courses: {
          allCourses: { $set: courses },
          updatedAt: { $set: Date.now() },
        },
      },
    });
  },
  [SET_GLOBAL_SEARCH_CURRICULUM_CONTEXT]: (state, action) => {
    const {
      payload: { selectedCurriculum = null },
    } = action;
    return update(state, {
      globalSearchBar: {
        selectedCurriculum: { $set: selectedCurriculum },
      },
    });
  },
  [SET_JUMP_TO_CURRICULUM_CONTEXT]: (state, action) => {
    const {
      payload: { selectedCurriculum = null },
    } = action;
    return update(state, {
      jumpTo: {
        selectedCurriculum: { $set: selectedCurriculum },
      },
    });
  },
  [SET_UBD_ASSESSMENT_TYPES]: (state, action) => {
    const {
      payload: { ubdAssessmentTypes },
    } = action;

    return update(state, {
      globalSearchBar: { ubdAssessmentTypes: { $set: ubdAssessmentTypes } },
    });
  },
  [SHOW_INTERCOM]: state => {
    return update(state, {
      showIntercom: { $set: true },
    });
  },
  [HIDE_INTERCOM]: state => {
    hideIntercomV1();
    return update(state, {
      showIntercom: { $set: false },
    });
  },
  [SHOW_NOTIFICATION_ICON_GLOBAL_TRAY]: state => {
    return update(state, {
      showNotificationIconGlobal: { $set: true },
    });
  },
  [HIDE_NOTIFICATION_ICON_GLOBAL_TRAY]: state => {
    return update(state, {
      showNotificationIconGlobal: { $set: false },
    });
  },
  [ADD_FEATURE_WITH_KEYBOARD_SHORTCUTS]: (state, action) => {
    const featuresToBeAdded = action.payload;
    return update(state, {
      featuresWithKeyboardShortcuts: (featuresWithKeyboardShortcuts = []) => {
        return featuresWithKeyboardShortcuts.concat(featuresToBeAdded);
      },
    });
  },
  [REMOVE_FEATURE_WITH_KEYBOARD_SHORTCUTS]: (state, action) => {
    const featuresToBeRemoved = action.payload;

    const activeFeatureWithKeyboardShortcuts = _.get(
      state,
      "activeFeatureWithKeyboardShortcuts",
      ""
    );

    const shouldCleanupActiveFeatureWithKeyboardShortcuts = _.includes(
      featuresToBeRemoved,
      activeFeatureWithKeyboardShortcuts
    );

    return update(state, {
      featuresWithKeyboardShortcuts: features =>
        _.filter(
          features,
          feature => !_.includes(featuresToBeRemoved, feature)
        ),
      activeFeatureWithKeyboardShortcuts: activeFeatureWithKeyboardShortcuts =>
        shouldCleanupActiveFeatureWithKeyboardShortcuts
          ? null
          : activeFeatureWithKeyboardShortcuts,
    });
  },
  [SET_ACTIVE_FEATURE_WITH_KEYBOARD_SHORTCUTS]: (state, action) => {
    const feature = action.payload;
    return update(state, {
      activeFeatureWithKeyboardShortcuts: { $set: feature },
    });
  },
  [SET_PLATFORM_SWITCHER_TAB]: (state, action) => {
    const { payload } = action;
    return update(state, {
      platformSwitcherTab: { $set: payload },
    });
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
